import React from 'react';
import { t } from '@lingui/macro';
import { createStackNavigator } from '@react-navigation/stack';

import DrawerOpen from '@src/components/DrawerOpen';
import LogoTitle from '@src/components/LogoTitle';
import { i18n } from '@src/i18n';
import ExploreScreen from '@src/screens/Explore';

import { DashboardExploreStackParamList } from './types';

const Stack = createStackNavigator<DashboardExploreStackParamList>();

const Component: React.FC = () => {
  return (
    <Stack.Navigator
      headerMode="screen"
      screenOptions={{
        title: `${i18n._(t`Explore`)} - ${i18n._(t`Youtopin`)}`,
        headerTitle: () => <LogoTitle />,
        headerLeft: () => <DrawerOpen />,
        headerTitleAlign: 'center',
      }}
    >
      <Stack.Screen name="Explore" component={ExploreScreen} />
    </Stack.Navigator>
  );
};

Component.displayName = 'DashboardExploreStack';

export default Component;
